import React, { ReactElement } from 'react';
import { centeredNotification } from '../../../utils/utility';

const NetworkConnectionStatus = (): ReactElement => {
  window.addEventListener('online', (): any => centeredNotification('Back online', 'success'));
  window.addEventListener('offline', (): any => centeredNotification('Please check your network connection.', 'warning'));

  return (
    <>
    </>
  );
};
export default NetworkConnectionStatus;
